
<div *ngIf="src && type && showMedia; else ngContent" [ngSwitch]="type" class="">
    <div *ngSwitchCase="'YouTube'" style="width:400px" class="video product-details">
        <div *ngIf="showPreview; else dialogTmp">
            <div (click)="clickMedia($event)" class="playVideo">
                <i class="fa fa-play"></i>
            </div>
            <img class="w-100 cursor-pointer" [src]="thumb"/>
        </div>
        <div class="rotate-wrapper" *ngIf="rotateToLandscape"><i class="fa fa-expand" (click)="rotate()"></i></div>
    </div>
    <ng-container *ngIf="noImage" ><img no-image [size]="noImageSize" *ngSwitchCase="'Image'" class="cursor-pointer" (click)="clickMedia($event)" [src]="src" [alt]="alt" [style]="inlineStyle"/></ng-container>
    <ng-container *ngIf="!noImage"><img *ngSwitchCase="'Image'" class="cursor-pointer" (click)="clickMedia($event)" [src]="src" [alt]="alt" [style]="inlineStyle"/></ng-container>
</div>
<ng-template #ngContent>
    <div (click)="clickMedia($event)">
        <ng-content></ng-content>
    </div>
</ng-template>

<ng-template #dialogTmp>
    <div class="image-dialog">
        <div class="rotate-wrapper" *ngIf="isRotate; else closeButton"><i class="fa  fa-compress" (click)="rotate()"></i></div>
        <ng-template #closeButton>
            <button mat-dialog-close type="button" class="close close-modal" aria-label="{{'Close Dialog'|translate}}">×</button>
        </ng-template>
        <div class="text-center modal-body p-0">
            <div [ngSwitch]="type">
                <iframe *ngSwitchCase = "'YouTube'" width="{{movieWidth}}" height="{{movieHeight}}" [src]="src | safe: 'resourceUrl'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                <ng2-pdfjs-viewer *ngSwitchCase = "'Document'" style="width: 100%; height:800px" pdfSrc="{{src}}" ></ng2-pdfjs-viewer>
                <img *ngSwitchCase = "'Image'" class="img-fluid" [src]="this.cdn && srcEnlarge? srcEnlarge :src" [alt]="" loading="lazy"/>
            </div>
        </div>
    </div>
</ng-template>
